const url = 'testecpb.com.br';
const domain = 'testecpb.com.br';
const protocolo = 'https://';
const login = `${protocolo}login.testecpb.com.br`;

export const environment = {
    production: false,
    title: '[D] ',
    env: 'dev',
    s3_path_temp: `${protocolo}snv.${domain}/temp-upload-files/`,
    cpb_edu_path_temp: `${protocolo}s.cpbedu.me/temp-upload-files/`,
    url,
    domain,
    protocolo,
    login,
    api: {
        path_s3: `https://s3-sa-east-1.amazonaws.com/s.testecpb.com.br/escola/`,
        path_s3_e_class: `https://s3-sa-east-1.amazonaws.com/s.testecpb.com.br/e_class/`,
        path_s3_snv_e_class: `https://snv.testecpb.com.br/e_class/`,
        path_s3_logotipo: `https://snv.testecpb.com.br/escola/logotipo/`,
    },
    web: {
        didaticos: `${protocolo}api-didaticos.testecpb.com.br/`,
        cron: `${protocolo}cron.testecpb.com.br/`,
        permissao: `${protocolo}api-permissao.testecpb.com.br/`,
        school: `${protocolo}api-school.testecpb.com.br/`,
        trilhas: `${protocolo}api-trilhas.testecpb.com.br/`,
    },
    zoom: {
        client_id: 'ZrOhIawUR96sgqujFKSGww',
        redirect_uri: 'https://login.testecpb.com.br/zoom',
    },
};
